// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"styles_checkboxWrapper__NoeUv","overlayPanelWrapper":"styles_overlayPanelWrapper__rCaF1"};